import { DEFAULT_STATE } from '../constants'

export const initialMoreFiltersState = {
  advancedFilters: DEFAULT_STATE.advancedFilters,
  contentFilter: DEFAULT_STATE.contentFilter,
  personalFilter: DEFAULT_STATE.personalFilter,
  purchaseFilter: DEFAULT_STATE.purchaseFilter,
}
